import { getComplaintStatuses } from "src/complaint/data-access/gateway";
import { useQuery } from "react-query";

export const useGetComplaintStatuses = (
  enabled: boolean,
  isSystemAdmin: boolean,
) => {
  return useQuery({
    queryFn: () => getComplaintStatuses(isSystemAdmin),
    queryKey: ["getComplaintStatuses", enabled],
    enabled,
  });
};
